<template>
  <div>
    <v-row class="mb-2" dense v-if="$allow(`psp-peserta-simulasi-ajar.statistik`)">
      <v-col v-for="analitik in analitik" v-bind="analitik.grid" :key="analitik.key">
        <v-card class="pa-0" flat elevation="1">
          <v-list class="pa-0">
            <v-list-item>
              <v-list-item-icon>
                <v-icon size="60" :color="analitik.color">{{ analitik.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-n5">
                <div :class="`font-weight-bold ${analitik.color}--text`">
                  <span v-html="analitik.label" />
                </div>
                <h2 :class="`${analitik.color}--text`">{{ $getDeepObj(analitik, 'value') || '0' }}</h2>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    kategori: {
      type: String,
      default: '',
    },
    analitik: {
      type: Array,
      default: () => [],
    },
    fungsi: {
      type: String,
      default: 'simulasi-ajar',
    },
  },
};
</script>
